import BrakeMatrix from "../BrakeMatrix";
import buildBrakeData from "../builders/buildBrakeData";

export default function BrakeSection({
    freioMonitor
}) {
    return (
        <BrakeMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Freio"
            groups={[
                { title: "Freio de atrito" },
                { title: "Sistema pneumático" }
            ]}
            extraItemsByCar={
                buildBrakeData(
                    freioMonitor
                )
            }
        />
    );
}